<!--
//================================================================================
// ID:-
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:NotFoundError
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/10/12 | 富士通株式会社         | 新規作成
//================================================================================
-->
<template>
	<main class="main">
		<div class="contents__main">
			<table border=0 align=center>
				<tr>
					<th valign=top>
						<font-awesome-icon icon="exclamation-triangle" class="exclamation-triangle" />
					</th>
					<td>
					</td>
				</tr>
			</table>
            <!-- エラーメッセージ -->
            <div class="contents__div--lineheight">
                <div>
                    <label class="contents__label--error">{{ E3006 }}</label>
                </div>
            </div>
		</div>
	</main>
</template>

<script>
import { E3006 } from '@/const/messageId';

export default {
    data: function() {
        return {
            E3006: E3006
        }
    },
}
</script>

<style scoped>
body {
	background: black;
}
.exclamation-triangle {
	color: #b30000;
	font-size: 54px;
}
.contents__label--error {
	color: #b30000;
}
.contents__div--lineheight {
	text-align: center;
}

/* 端末がPCの場合 */
@media screen and (min-width: 768px) {
    .contents__label--error {
		font-size: 16px;
	}
	.contents__div--lineheight {
		margin-top: 15px;
		line-height: 2em;
	}
}

/* 端末がスマホの場合 */
@media screen and (max-width: 767px) {
	.exclamation-triangle {
		font-size: 64px;
	}
	.contents__div--lineheight {
        margin-top: 15px;
    }
    .contents__label--error {
		font-size: 18px;
	}
}
</style>